export function getActiveSetting(setting) {
	return setting.reduce((acc, item) => {
		if (item.settings && item.value) {
			acc.push(item['value']);
		}
		return acc;
	}, []);
}
